export type TClientOs = 'WEB' | 'IOS' | 'ANDROID';

/**
 * Суперапп Choco подменяет вебвью весь User-Agent на "ChocoSuperApp/iOS/7.20.15"
 * — стандартных маркеров iPhone/Android в нём нет, поэтому платформу читаем
 * из самой строки.
 */
const SUPERAPP_AGENT_PLATFORM = /ChocoSuperApp\/(iOS|Android)/i;

/**
 * ОС устройства по User-Agent для заголовка X-OS.
 *
 * Вызывается только из вебвью супераппа Choco: остальным рантаймам (браузер,
 * партнёрские нативки) по договорённости с бордами полагается WEB.
 */
export const getDeviceOs = (): TClientOs => {
	const ua = navigator.userAgent || '';

	const superappPlatform = SUPERAPP_AGENT_PLATFORM.exec(ua);

	if (superappPlatform) {
		return superappPlatform[1].toLowerCase() === 'ios' ? 'IOS' : 'ANDROID';
	}

	if (/iPhone|iPad|iPod/i.test(ua)) {
		return 'IOS';
	}

	if (/Android/i.test(ua)) {
		return 'ANDROID';
	}

	// iPadOS 13+ отдаёт десктопный UA с Macintosh — отличаем по тач-событиям
	if (ua.includes('Macintosh') && 'ontouchend' in document) {
		return 'IOS';
	}

	return 'WEB';
};
